var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.STOCK_DELIVERY_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("form.oddNumbers"),
                            prop: "queryCode",
                          },
                        },
                        [
                          _c("BjInputCode", {
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.queryCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "queryCode", $$v)
                              },
                              expression: "queryParams.queryCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("BjSelectChannelStore", {
                    attrs: {
                      span: _vm.colSpan,
                      "query-params": _vm.queryParams,
                      "query-props": ["channelTypeCode", "shopIdList"],
                      "store-option-value": "id",
                      multiple: "",
                    },
                  }),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessStockDeliveryInform.header.status"
                            ),
                            prop: "status",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.ORDER_STOCK_OUT_TYPE_LIST,
                            },
                            model: {
                              value: _vm.queryParams.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "status", $$v)
                              },
                              expression: "queryParams.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessStockDeliveryInform.header.outLogicWarehouseCode"
                            ),
                            prop: "outLogicWarehouseCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t(
                                "BusinessStockDeliveryInform.header.outLogicWarehouseCodeText"
                              ),
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.outLogicWarehouseCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "outLogicWarehouseCode",
                                  $$v
                                )
                              },
                              expression: "queryParams.outLogicWarehouseCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.createTimeText"),
                            prop: "beginCreationDate",
                          },
                        },
                        [
                          _c("BjDateTimerangePicker", {
                            attrs: {
                              placeholder: _vm.$t("table.createTimeText"),
                            },
                            model: {
                              value: _vm.queryParamsTime,
                              callback: function ($$v) {
                                _vm.queryParamsTime = $$v
                              },
                              expression: "queryParamsTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            this.$route.name === "BusinessStockDeliveryInformIndex"
              ? {
                  key: "tableOperation",
                  fn: function (tableOperationProp) {
                    return [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: tableOperationProp.notSingle,
                              },
                              on: { click: _vm.onDeliver },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("BusinessStockDeliveryInform.ship")
                                ) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      [
                                        "code",
                                        "platformOrderCode",
                                        "orderCode",
                                      ].includes(col.prop)
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onView(
                                                        scope.row,
                                                        col.prop
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row[col.prop])
                                                  ),
                                                ]
                                              ),
                                              _c("BjCopyIcon", {
                                                staticClass: "ml10",
                                                attrs: {
                                                  copy: scope.row[col.prop],
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : col.prop === "status"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_STOCK_OUT_TYPE_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c("DeliverGoodsDialog", {
        ref: "DeliverGoods",
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }